(function ($) {

    $(document).ready(function () {

        // Open mobile menu
        $(".navbar-toggle").on("click", function (e) {
            e.preventDefault();
            if ($(this).hasClass("collapsed")) {
                $(".header").addClass("mobile-activated-menu");
                $("html").addClass("overflow-hidden"); // block scroll
                $("body").addClass("show-bg"); // block scroll

                setTimeout(() => {
                    $(".header-mobile .location-dropdown").addClass("show-dropdown");
                }, 300);
            } else {
                $(".header").removeClass("mobile-activated-menu");
                $("html").removeClass("overflow-hidden");
                $("body").removeClass("show-bg");
                $(".header-mobile .location-dropdown").removeClass("show-dropdown");
            }
        });

        //open search
        $("#header .search-icon").on("click", function () {
            if (window.innerWidth <= 1250) {
                $(".navbar-toggle").click();
            }
            $(".search-form-wrap").addClass("visible");
            $("html").addClass("overflow-hidden"); // block scroll
            $("body").addClass("show-bg"); // block scroll
        });
        //close search
        $("#header .close-btn").on("click", function () {
            $(".search-form-wrap").removeClass("visible");
            $("html").removeClass("overflow-hidden");
            $("body").removeClass("show-bg");
        });

        //select multisite
        const $selector = $(".location-selector");
        const $selectedLocation = $(".selected-location");
        const $dropdown = $(".location-dropdown");
        const $dropdownItems = $dropdown.find("li");

        // check mobile version
        function isMobile() {
            return window.innerWidth <= 767;
        }

        window.addEventListener('scroll', () => {
            $selector.removeClass('open')
        });

        $selectedLocation.on("click", function () {
            $selector.toggleClass("open");
        });

        $dropdownItems.on("click", function () {  
            const $this = $(this);
            const url = $this.data("url");
            $dropdownItems.removeClass("active");
            $this.addClass("active");

            $selector.removeClass("open");

            if (url) {
                window.location.href = url;
            }
        });

        // close dropdown out of area
        $(document).on("click", function (e) {
            if (!$selector.is(e.target) && !$selector.has(e.target).length) {
                $selector.removeClass("open");
            }
        });


    });


})(jQuery);

searchForms = document.querySelectorAll(".form-search")
searchForms.forEach(form => {
    const clearInput = form.querySelector(".clear-input");
    const searchInput = form.querySelector("input");
    const searchSubmit = form.querySelector("button");
    const searchIcon = document.querySelector(".search-icon");
    const burgerIcon = document.querySelector(".navbar-toggle");
    if (searchInput.value.trim() === "") {
        searchSubmit.classList.add("disabled");
    }

    searchInput.addEventListener("input", () => {
        if (searchInput.value.trim() === "") {
            searchSubmit.classList.add("disabled");
        } else {
            searchSubmit.classList.remove("disabled");
        }
    });

    searchInput.addEventListener("input", () =>
        clearInput.style.display = searchInput.value ? "block" : "none"
    );

    clearInput.addEventListener("click", () => {
        searchInput.value = "";
        clearInput.style.display = "none";
        searchSubmit.classList.add("disabled");
    });

    searchIcon.addEventListener("click", () => searchInput.value = "");
    burgerIcon.addEventListener("click", () => searchInput.value = "");
    searchIcon.addEventListener("click", () => searchSubmit.classList.add("disabled"));
    burgerIcon.addEventListener("click", () => searchSubmit.classList.add("disabled"));
});



//
// const current = document.querySelectorAll(".header__current");
// const select = document.querySelectorAll(".header__select");
//
// if (current && select) {
//     current.addEventListener("click", (e) => {
//         e.stopPropagation();
//         select.classList.toggle("active");
//         current.classList.toggle("active");
//         const location = document.querySelector('.location-selector')
//         if (location) {
//             location.classList.remove('open')
//         }
//     });
//
//     document.addEventListener("click", (e) => {
//         if (!select.contains(e.target) && !current.contains(e.target)) {
//             select.classList.remove("active");
//             current.classList.remove("active");
//         }
//     });
//
//
//     window.addEventListener('scroll', () => {
//         select.classList.remove("active");
//         current.classList.remove("active");
//     });
//
// }


const currentElements = document.querySelectorAll(".header__current");
const selectElements = document.querySelectorAll(".header__select");

currentElements.forEach((current, index) => {
    const select = selectElements[index];

    if (select) {
        current.addEventListener("click", (e) => {
            e.stopPropagation();

            // Закриваємо всі інші відкриті селекти
            selectElements.forEach((sel, i) => {
                if (i !== index) sel.classList.remove("active");
            });
            currentElements.forEach((cur, i) => {
                if (i !== index) cur.classList.remove("active");
            });

            // Перемикаємо поточний
            select.classList.toggle("active");
            current.classList.toggle("active");

            // Закриваємо location-selector (якщо є)
            const location = document.querySelector('.location-selector');
            if (location) {
                location.classList.remove('open');
            }
        });
    }
});

// Закриття по кліку поза селектами
document.addEventListener("click", (e) => {
    selectElements.forEach((select, i) => {
        const current = currentElements[i];
        if (!select.contains(e.target) && !current.contains(e.target)) {
            select.classList.remove("active");
            current.classList.remove("active");
        }
    });
});

// Закриття при скролі
window.addEventListener("scroll", () => {
    selectElements.forEach((select, i) => {
        select.classList.remove("active");
        currentElements[i].classList.remove("active");
    });
});
